const mathToFixed = (num) => {
  if (num !== undefined && num !== null) {
    return num.toFixed(2) // 保留两位小数
  }
  return '0.00' // 如果数字是undefined或null，返回'0.00'
}
export default {mathToFixed}
